import { type ValueOf } from '@dni-types/utilities/value-of'

export const PAYMENT_DIALOG_TYPE = {
  CREDIT_CARD: 'credit_card',
  APPLE_PAY: 'apple_pay',
  ALIPAY_HK: 'alipay_hk',
  REDIRECT_APM: 'redirect_apm',
} as const

export type PaymentDialogType = ValueOf<typeof PAYMENT_DIALOG_TYPE>
